import { RouteConfig } from 'vue-router';
import BrokerCaseDetail from '@/views/damageassessorcases/BrokerCaseDetail.vue';
import DamageAssessorCaseOverview from '@/views/damageassessorcases/DamageAssessorCaseOverview.vue';
import DamageAssessorCaseDetail from '@/views/damageassessorcases/DamageAssessorCaseDetail.vue';
import PageModal from '@/components/modals/PageModal.vue';
import KilometrageChangeCard from '@/views/management/Customer/Vehicles/KilometrageChangeCard.vue';
import DamageAssessorCaseChangeAssessorModal from '@/views/damageassessorcases/DamageAssessorCaseChangeAssessorModal.vue';
import DamageAssessorCaseSetAppointmentModal from '@/views/damageassessorcases/DamageAssessorCaseSetAppointmentModal.vue';
import DamageAssessorCaseSetExpertiseModal from '@/views/damageassessorcases/DamageAssessorCaseSetExpertiseModal.vue';
import BrokerCompensationOverview from '@/views/damageassessorcases/BrokerCompensationOverview.vue';
import CompensationFinishModal from '@/views/damageassessorcases/CompensationFinishModal.vue';
import CompensationUpdateModal from '@/views/damageassessorcases/CompensationUpdateModal.vue';
import BrokerCaseOverview from '@/views/damageassessorcases/BrokerCaseOverview.vue';
import DamageAssessorCaseCreate from '@/views/damageassessorcases/DamageAssessorCaseCreate.vue';
import DamageAssessorCaseEditPerson from '@/components/damageassessorcases/edits/DamageAssessorCaseEditPerson.vue';
import DamageAssessorCaseEditVehicle from '@/components/damageassessorcases/edits/DamageAssessorCaseEditVehicle.vue';
import DamageAssessorCaseEditAccident from '@/components/damageassessorcases/edits/DamageAssessorCaseEditAccident.vue';
import DamageAssessorCaseEditAccidentModal
	from '@/components/damageassessorcases/modals/DamageAssessorCaseEditAccidentModal.vue';
import DamageAssessorCaseEditPhotosModal
	from '@/components/damageassessorcases/modals/DamageAssessorCaseEditPhotosModal.vue';
import DamageAssessorCaseEditLawyerModal
	from '@/components/damageassessorcases/modals/DamageAssessorCaseEditLawyerModal.vue';

const routes: Array<RouteConfig> = [
	{
		path: '/broker-cases',
		name: 'brokerCaseOverview',
		component: BrokerCaseOverview,
	},
	{
		path: '/damage-assessor-cases',
		name: 'damageAssessorCaseOverview',
		component: DamageAssessorCaseOverview,
	},
	{
		path: '/broker-compensation',
		name: 'compensations',
		component: BrokerCompensationOverview,
		children: [
			{
				path: '/broker-compensation/finish',
				name: 'finishCompensation',
				component: PageModal,
				props: {
					title: 'Vergütung abschließen',
					component: CompensationFinishModal,
					modalStyle: 'width: fit-content; align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: { disableScroll: true },
			},
			{
				path: '/broker-compensation/update',
				name: 'updateCompensation',
				component: PageModal,
				props: {
					title: 'Vergütung anpassen',
					component: CompensationUpdateModal,
					modalStyle: 'width: fit-content; align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: { disableScroll: true },
			},
		],
	},
	{
		path: '/damage-assessor-cases/create',
		name: 'damageAssessorCaseCreate',
		component: DamageAssessorCaseCreate,
	},
	{
		path: '/damage-assessor-cases/:id',
		name: 'damageAssessorCaseDetail',
		component: DamageAssessorCaseDetail,
		children: [
			{
				path: 'change-damage-assessor',
				name: 'changeDamageAssessor',
				component: PageModal,
				props: {
					title: 'Gutachterfall - Gutachter ändern',
					component: DamageAssessorCaseChangeAssessorModal,
					modalStyle: 'width: fit-content; align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: {
					disableScroll: true,
				},
			},
			{
				path: 'change-appointment',
				name: 'changeAppointment',
				component: PageModal,
				props: {
					title: 'Gutachterfall - Termin ändern',
					component: DamageAssessorCaseSetAppointmentModal,
					modalStyle: 'width: fit-content; align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: {
					disableScroll: true,
				},
			},
			{
				path: 'change-examination',
				name: 'changeExamination',
				component: PageModal,
				props: {
					title: 'Gutachterfall - Begutachtungstermin ändern',
					component: DamageAssessorCaseSetExpertiseModal,
					modalStyle: 'width: fit-content; align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: {
					disableScroll: true,
				},
			},
			{
				path: 'edit-accident',
				name: 'damageAssessorCaseEditAccident',
				component: PageModal,
				props: {
					title: 'Gutachterfall - Unfalldaten bearbeiten',
					component: DamageAssessorCaseEditAccidentModal,
					modalStyle: 'width: 1000px; max-width: calc(100vw - 64px); align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: {
					disableScroll: true,
				},
			},
			{
				path: 'edit-accident',
				name: 'damageAssessorCaseEditAccident',
				component: PageModal,
				props: {
					title: 'Gutachterfall - Unfalldaten bearbeiten',
					component: DamageAssessorCaseEditAccidentModal,
					modalStyle: 'width: 1000px; max-width: calc(100vw - 64px); align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: {
					disableScroll: true,
				},
			},
			{
				path: 'edit-lawyer',
				name: 'damageAssessorCaseEditLawyer',
				component: PageModal,

				props: {
					title: 'Gutachterfall - Kanzlei verwalten',
					component: DamageAssessorCaseEditLawyerModal,
					modalStyle: 'width: 1000px; max-width: calc(100vw - 64px); align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: {
					disableScroll: true,
				},
			},
			{
				path: 'edit-photos',
				name: 'damageAssessorCaseEditPhotos',
				component: PageModal,

				props: {
					title: 'Gutachterfall - Fotos bearbeiten',
					component: DamageAssessorCaseEditPhotosModal,
					modalStyle: 'width: 1000px; max-width: calc(100vw - 64px); align-self: center',
					reAddConfirmLeaving: true,
				},

				meta: {
					disableScroll: true,
				},
			},
		],
	},
	{
		path: '/damage-assessor-cases/:id/person/edit',
		name: 'damageAssessorCaseEditPerson',
		component: DamageAssessorCaseEditPerson,
	},
	{
		path: '/damage-assessor-cases/:id/vehicle/edit',
		name: 'damageAssessorCaseEditVehicle',
		component: DamageAssessorCaseEditVehicle,
	},
	{
		path: '/damage-assessor-cases/:id/accident/edit',
		name: 'damageAssessorCaseEditAccident',
		component: DamageAssessorCaseEditAccident,
	},
	{
		path: '/broker-cases/:id',
		name: 'brokerCaseDetail',
		component: BrokerCaseDetail,
	},
];

export default routes;
